import { useRef, useEffect } from 'react';

import { useResetDeviceMutation } from 'store/api/clover';

type CloverResetDeviceAction = ReturnType<typeof useResetDeviceMutation>[0];

interface UseUnmountCancelAction {
  deviceId: number;
  isManualCreditPaymentEnabled?: boolean;
  cloverResetDevice: CloverResetDeviceAction;
}

/**
 * Unmounts the cancel action mutation when the component is unmounted.
 * If isManualCreditPaymentEnabled is false, it will reset the device when the component is unmounted.
 * @param {UseUnmountCancelAction} params - The object containing deviceId, cloverResetDevice and isManualCreditPaymentEnabled.
 * @returns {void}
 */
export const useUnmountCancelAction = ({
  deviceId,
  cloverResetDevice,
  isManualCreditPaymentEnabled,
}: UseUnmountCancelAction) => {
  const deviceIdRef = useRef(deviceId);

  useEffect(() => {
    deviceIdRef.current = deviceId;
  }, [deviceId]);

  useEffect(() => {
    return () => {
      if (deviceIdRef.current && !isManualCreditPaymentEnabled) {
        cloverResetDevice({ deviceId: deviceIdRef.current });
        console.log('[Checkout] Page unmounted');
      }
    };
  }, [isManualCreditPaymentEnabled]);
};
